<template>
  <div :class="['font-semibold mb-1', hideMobileDetails ? 'mt-1' : 'mt-6']">
    {{ getLocalizedEventValue(checkoutStore.event, locale, 'info1') }}
  </div>

  <div :class="['text-xs text-text gap-1 md:gap-4 flex-col md:flex-row', hideMobileDetails ? 'hidden md:flex' : 'flex']">
    <CheckoutEventDate :event="checkoutStore.event" :showTime="true"/>
    <div>
         {{ checkoutStore.event.venuename }}
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import { useCheckoutStore } from '@/stores/checkoutStore';
  import { getLocalizedEventValue } from '@/utils/eventItemUtil';

  import CheckoutEventDate from './CheckoutEventDate.vue';
  
  withDefaults(defineProps<{
    hideMobileDetails?: boolean;
  }>(), {
    hideMobileDetails: false,
  });

  const { locale } = useI18n();
  const checkoutStore = useCheckoutStore();

</script>
